export enum RepairTypes {
    GET_REPAIR_BY_ID_LOADING = "GET_REPAIR_BY_ID_LOADING",
    GET_REPAIR_BY_ID_SUCCESS = "GET_REPAIR_BY_ID_SUCCESS",
    GET_REPAIR_BY_ID_FAILURE = "GET_REPAIR_BY_ID_FAILURE",
    CREATE_REPAIR_LOADING = "CREATE_REPAIR_LOADING",
    CREATE_REPAIR_SUCCESS = "CREATE_REPAIR_SUCCESS",
    CREATE_REPAIR_FAILURE = "CREATE_REPAIR_FAILURE",
    GET_REPAIRS_LOADING = "GET_REPAIRS_LOADING",
    GET_REPAIRS_SUCCESS = "GET_REPAIRS_SUCCESS",
    GET_REPAIRS_FAILURE = "GET_REPAIRS_FAILURE",
    SET_REPAIR_FILTER_STATUS = "SET_REPAIR_FILTER_STATUS",
    SET_REPAIR_FILTER_SEARCH = "SET_REPAIR_FILTER_SEARCH",
    UPDATE_REPAIR_LOADING = "UPDATE_REPAIR_LOADING",
    UPDATE_REPAIR_SUCCESS = "UPDATE_REPAIR_SUCCESS",
    UPDATE_REPAIR_FAILURE = "UPDATE_REPAIR_FAILURE"
} 